import { useEffect } from 'react';
import useStore from '../store/useStore';

// Extend window interface to include ReactNativeWebView
declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
  }
}

export function NetworkMonitor() {
  const isOnline = useStore((state) => state.isOnline);

  useEffect(() => {
    // Communicate network status to React Native WebView
    const sendNetworkStatus = () => {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'NETWORK_STATUS',
          payload: { isOnline }
        }));
      }
    };

    sendNetworkStatus();
    
    // Also send PWA status updates
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 'SERVICE_WORKER_READY',
            payload: { scope: registration.scope }
          }));
        }
      });
    }
  }, [isOnline]);

  return null;
}